import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { parseVimeoUrl } from './parseVimeoUrl';
import type { OptimizedVimeoReference } from './VimeoVideo.types';

/**
 * For call sites that keep their original embed as the flag-off branch: render no video while
 * `isFlagLoading` (swapping embeds would load it twice), the optimized player when `video` is set,
 * otherwise the original embed.
 */
export const useOptimizedVimeoReference = (videoUrl: string | null | undefined): OptimizedVimeoReference => {
  const [isOptimized, isFlagLoading] = useIsFeatureEnabled('vimeoPlaybackOptimizationEnabled');
  const reference = useMemo(() => (videoUrl ? parseVimeoUrl(videoUrl) : null), [videoUrl]);
  return { video: isOptimized && !isFlagLoading ? reference : null, isFlagLoading };
};
